import {fullAddressRoundRobinApi} from "./fullAddressRoundRobinApi"
import {disPlayListOfServices} from "./disPlayListOfServices";
export const servieModal = {
    enable:false as boolean
}
export function servicesListDisplayModal(postalCode:any){
    fullAddressRoundRobinApi(postalCode,false,()=>{
           disPlayListOfServices(postalCode);
    },'');
}